import React from 'react';
import Icon from '../../icon';
import Tooltip from '../../tooltip';

const COLOR_TILE_INDETERMINATE_TOOLTIP_ID = 'color-tile-indeterminate';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
const IndeterminateTile = ({
  className,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | undefined'.
  tooltipText = null,
  isTouchDevice = false,
  onClick,
}) => (
  <>
    <div
      className={className}
      onClick={onClick}
      data-tip
      data-for={COLOR_TILE_INDETERMINATE_TOOLTIP_ID}
    >
      <Icon size="20" glyph="minus" withScaleFactor />
    </div>
    {!isTouchDevice && tooltipText && (
      <Tooltip id={COLOR_TILE_INDETERMINATE_TOOLTIP_ID} text={tooltipText} />
    )}
  </>
);

export default IndeterminateTile;
